"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHPersistentReference = void 0;
const KHReference_1 = require("./KHReference");
/**
 * Variable reference that saves values to json. If the value being saved is one
 * other than number, boolean, json, or string, an overridden class should be
 * added that supports serializing and deserializing.
 *
 * It will only persist if the options parameter is set.
 */
class KHPersistentReference extends KHReference_1.KHReference {
    constructor(key, defaultValue, saveOnChange = true) {
        super(defaultValue);
        this.key = key;
        this.saveOnChange = saveOnChange;
        this.defaultValue = defaultValue;
    }
    setFromJson(json) {
        var _a;
        let value = (_a = json[this.key]) !== null && _a !== void 0 ? _a : this.defaultValue;
        // Bypass this class's set to avoid a save loop.
        super.set(value);
    }
    addToJson(json) {
        json[this.key] = this.value;
    }
    set(value) {
        super.set(value);
        if (this.saveOnChange) {
            this.save();
        }
    }
    /**
     * Triggers a save on its owning options, if present. Useful if you're
     * altering the internals of a JSON object.
     */
    save() {
        var _a;
        (_a = this.options) === null || _a === void 0 ? void 0 : _a.save();
    }
}
exports.KHPersistentReference = KHPersistentReference;
